import axiosInstance from './common/export'
import axiosJava from './common/java'

export default {
    //修改密码
    modifyPassword(old_password, new_password, first_password) {
        return axiosInstance.post('/users/change_password', {
            old_password: old_password,
            new_password: new_password,
            first_password: first_password
        })
    },
    relaod_password(password, userId) {
        return axiosInstance.post('/users/relaod_password', {
            password: password,
            id: userId
        })
    },

    //修改邮箱
    modifyEmail(email) {
        return axiosInstance.put('/users', {email: email})
    },
    //获取BU数据
    getbu() {
        return axiosInstance.get('/sys/masterdata/bu')
    },
    //获取公共数据
    getCommon() {
        return axiosInstance.get('/sys/masterdata/common')
    },
    //获取工作流类型数据
    getflowtype() {
        return axiosInstance.get('/sys/masterdata/flowtype')
    },
    // 获取查询申请类型
    getqueryflowtype() {
        return axiosInstance.get('/sys/masterdata/queryflowtype')
    },
    // 获取可展开的产品线
    getproductParentList() {
        return axiosInstance.get("/sys/productParentList")
    },
    // 获取可展开的产品线（一期）
    getproductLineParentList() {
        return axiosInstance.get("/sys/productParentLineList")
    },
    //获取医院数据
    getHospital(value) {
        return axiosInstance.get('/sys/masterdata/hospitals', {params: value})
    },
    //获取注册验证码
    getRegistercode(data) {
        return axiosInstance.post('/users/registercode', {email: data})
    },
    //注册
    register(data) {
        console.log(data);
        return axiosInstance.post('/users/register', data)
    },
    registerForJava(data) {
        console.log(data);
        return axiosInstance.post('/users/secondaryRegister', data)
    },
    //删除附件
    deleteAttachment(id) {
        console.log(id);
        return axiosInstance.put(`/attachment/${id}`)
    },
    //提交一级经销商名称变更信息
    subChangeName(data) {
        return axiosJava.post('/distributor/subChangeName', data)
    },
    //查询经销商名称
    getCompanyName(value) {
        console.log(value);
        return axiosJava.post('/distributor/getCompanyName', value)
    },
    javaRegister(value) {
        return axiosJava.post('/user/register', value)
    },
    javaLogin(value) {
        return axiosJava.post('/login', value)
    },
    getMyTaskData(value) {
        return axiosJava.post('/distributor/getTaskList', value)
    },
    getMyApplication(value) {
        return axiosJava.post('/homeDisplay/myApplication', value)
    },
    getInformationService(value) {
        return axiosJava.post('/homeDisplay/informationService', value)
    },
    exportone(value) {
        return axiosJava.post('/distributor/exportone', value)
    },
    exportAnt(value) {
        return axiosJava.post('/distributor/export', value)
    },
    exportIndicator(value) {
        return axiosJava.post('/distributor/exportIndicator', value)
    },
    getInformationAuthorizationService(value) {
        return axiosJava.post('/homeDisplay/informationAuthorizationService', value)
    },
    getInformationAuthorizationServiceEnd(value) {
        return axiosJava.post('/homeDisplay/informationAuthorizationServiceEnd', value)
    },
    getInformationSecondary(value) {
        return axiosJava.post('/homeDisplay/informationSecondary', value)
    },
    getSecondaryCompany(value) {
        return axiosJava.post('/homeDisplay/getSecondaryCompany', value)
    },
    getInformationAll(value) {
        return axiosJava.post('/homeDisplay/informationAll', value)
    },
    getInformationSecondaryAll(value) {
        return axiosJava.post('/homeDisplay/informationSecondaryAll', value)
    },
    //次级经销商新建接口
    secondaryDealerNewInstall(value) {
        return axiosJava.post('/secondaryDealerNew/install', value)
    },
    getOneDealerNew(value) {
        return axiosJava.post('/secondaryDealerNew/getOneDealerNew', value)
    },
    getProductLine(value) {
        return axiosJava.post('/secondaryDealerNew/getProductLine', value)
    },
    getProvicesAndCitys(value) {
        return axiosJava.post('/secondaryDealerNew/getProvicesAndCitys', value)
    },
    getHospitalByCompany(value) {
        return axiosJava.post('/secondaryDealerNew/getHospital', value)
    },
    dealerNewThrough(value) {
        return axiosJava.post('/secondaryDealerNew/through', value)
    },
    //根据id查询信息
    getChangeNameById(data) {
        return axiosJava.post('/distributor/getNameChangeById', data)
    },
    //审批一级经销商名称更改
    subNameApproval(data) {
        return axiosJava.post('/distributor/subNameApproval', data)
    },
    getSecondaryDealerNew(value) {
        return axiosJava.post('/secondaryDealerNew/getDealerNew', value)
    },
    //次级经销商无需审批的更改接口
    secondaryCompanyInformationInstall(value) {
        return axiosJava.post('/secondaryCompanyInformation/install', value)
    },
    getCompanyInformation(value) {
        return axiosJava.post('/secondaryCompanyInformation/getCompanyInformation', value)
    },
    //二级经销商资质变更审批流程接口
    secondaryDealerChangeInstall(value) {
        return axiosJava.post('/secondaryDealerChange/install', value)
    },
    secondaryDealerChangeSubInstall(value) {
        return axiosJava.post('/secondaryDealerChange/sub_install', value)
    },
    getDealerChange(value) {
        return axiosJava.post('/secondaryDealerChange/getDealerChange', value)
    },
    getDealerChangeById(value) {
        return axiosJava.post('/secondaryDealerChange/getDealerChangeById', value)
    },
    DealerChangeThrough(value) {
        return axiosJava.post('/secondaryDealerChange/through', value)
    },
    DealerChangeSubThrough(value) {
        return axiosJava.post('/secondaryDealerChange/sub_through', value)
    },
    //DD续约接口
    secondaryDdRenewInstall(value) {
        return axiosJava.post('/secondaryDdRenew/install', value)
    },
    getDdRenew(value) {
        return axiosJava.post('/secondaryDdRenew/getDdRenew', value)
    },
    getDdRenewByCompany(value) {
        return axiosJava.post('/secondaryDdRenew/getDdRenewByCompany', value)
    },
    qualityHistory(value) {
        return axiosJava.post('/secondaryDdRenew/qualityHistory', value)
    },
    submitReview(value) {
        return axiosJava.post('/secondaryDdRenew/submitReview', value)
    },
    saveWorkflow(value) {
        return axiosJava.post('/secondaryDdRenew/saveWorkflow', value)
    },
    getHisApproval(value) {
        return axiosJava.post('/secondaryDdRenew/getHisApproval', value)
    },
    //查询daac
    getDaac(data) {
        return axiosJava.post('/daacFile/getDaac', data)
    },
    getChannel(data) {
        return axiosJava.post('/undo/getChannel', data)
    },
    getSalesList(data) {
        return axiosJava.post('/undo/getSalesList', data)
    },
    cancelWorkflow(value) {
        return axiosJava.post('/secondaryDdRenew/cancelWorkflow', value)
    },
    through(value) {
        return axiosJava.post('/secondaryDdRenew/through', value)
    },
    //新建招标授权
    jurisdictionInstall(value) {
        return axiosJava.post('/jurisdiction/install', value)
    },
    jurisdictionSubmit(value) {
        return axiosJava.post('/jurisdiction/submit', value)
    },
    delectJurisdiction(value) {
        return axiosJava.post('/jurisdiction/delectJurisdiction', value)
    },
    jurisdictionThrough(value) {
        return axiosJava.post('/jurisdiction/through', value)
    },
    getJurisdiction(value) {
        return axiosJava.post('/jurisdiction/getJurisdiction', value)
    },
    getJurisdictionByCompanyName(value) {
        return axiosJava.post('/jurisdiction/getJurisdictionByCompanyName', value)
    },
    //次级授权变更
    submitReviewChange(value) {
        return axiosJava.post('/secondaryAuthorizationChange/submitReview', value)
    },
    getAuthorizationInfo(value) {
        return axiosJava.post('/secondaryAuthorizationChange/getAuthorizationInfo', value)
    },
    throughAuthorization(value) {
        return axiosJava.post('/secondaryAuthorizationChange/through', value)
    },
    getOneAuthorization(value) {
        return axiosJava.post('/secondaryAuthorizationChange/getOneAuthorization', value)
    },
    searchCertificates(value) {
        return axiosJava.post('/distributor/searchCertificates', value)
    },

    searchCertificatesTest(value) {
        return axiosJava.post('/provideCertificateChange/searchCertificatesTest', value)
    },
    getBu(value) {
        return axiosJava.post('/specialAuthorization/getBu', value)
    },
    subCertificates(value) {
        return axiosJava.post('/distributor/subCertificates', value)
    },

    subCertificatesTest(value) {
        return axiosJava.post('/provideCertificateChange/subCertificatesTest', value)
    },
    subCertificatesChange(value) {
        return axiosJava.post('/distributor/subCertificatesChange', value)
    },
    subCertificatesChangeTest(value) {
        return axiosJava.post('/provideCertificateChange/subCertificatesChangeTest', value)
    },
    getCompanyNameCn(value) {
        console.log(value);
        return axiosJava.post('/distributor/getCompanyNameCn', value)
    },
    changeWarehouse(value) {
        return axiosJava.post('/distributor/changeWarehouse', value)
    },
    subWarehousesChange(value) {
        return axiosJava.post('/distributor/subWarehousesChange', value)
    },
    subWarehousesChangeApp(value) {
        return axiosJava.post('/distributor/subWarehousesChangeApp', value)
    },
    getCompanyNameCnInvoice(value) {
        return axiosJava.post('/distributor/getCompanyNameCnInvoice', value)
    },
    subInvoiceInfo(value) {
        return axiosJava.post('/distributor/subInvoiceInfo', value)
    },
    subInvoiceInfoApp(value) {
        return axiosJava.post('/distributor/subInvoiceInfoApp', value)
    },
    getManagementChange(value) {
        return axiosJava.post('/distributor/getManagementChange', value)
    },
    subManagementChange(value) {
        return axiosJava.post('/distributor/subManagementChange', value)
    },
    subManagementChangeApp(value) {
        return axiosJava.post('/distributor/subManagementChangeApp', value)
    },
    getContactInfo(value) {
        return axiosJava.post('/distributor/getContactInfo', value)
    },
    subContactInfo(value) {
        return axiosJava.post('/distributor/subContactInfo', value)
    },
    subContactInfoApp(value) {
        return axiosJava.post('/distributor/subContactInfoApp', value)
    },
    changeContactInfo(value) {
        return axiosJava.post('/distributor/changeContactInfo', value)
    },
    changeContactInfoHis(value) {
        return axiosJava.post('/distributor/changeContactInfoHis', value)
    },
    getproviderPersonnelInfo(value) {
        return axiosJava.post('/distributor/getproviderPersonnelInfo', value)
    },
    subProviderPersonnelInfo(value) {
        return axiosJava.post('/distributor/subProviderPersonnelInfo', value)
    },
    subProviderPersonnelInfoApp(value) {
        return axiosJava.post('/distributor/subProviderPersonnelInfoApp', value)
    },
    getOneQualificationsChange(value) {
        return axiosJava.post('/distributor/getOneQualificationsChange', value)
    },
    subOneQualificationsChange(value) {
        return axiosJava.post('/distributor/subOneQualificationsChange', value)
    },
    getJurisdictionByName(value) {
        return axiosJava.post('/jurisdiction/getJurisdictionByName', value)
    },

    //一级经销商BU
    getCompanyBu(value) {
        return axiosJava.post('/secondDealer/getCompanyBu', value)
    },
    checkOne(value) {
        return axiosJava.post('/secondDealer/checkOne', value)
    },
    //一级经销商BU对应的区域
    getCompanyRegion(value) {
        return axiosJava.post('/secondDealer/getCompanyRegion', value)
    },
    getBUList(value) {
        return axiosJava.post('/receiveController/getBUList', value)
    },
    checkReceiveEmail(value) {
        return axiosJava.post('/receiveController/checkReceiveEmail', value)
    },
    checkPhoneNumber(value) {
        return axiosJava.post('/receiveController/checkPhoneNumber', value)
    },

    noSubQuotient(value) {
        return axiosJava.post('/secondDealer/noSubQuotient', value)
    },
    getAnnualIndicator(value) {
        return axiosJava.post('/secondaryAuthorizationChange/getAnnualIndicator', value)
    },
    getCompanyProductLine(value) {
        return axiosJava.post('/secondDealer/getCompanyProductLine', value)
    },
    getCompanyProvice(value) {
        return axiosJava.post('/secondDealer/getCompanyProvice', value)
    },
    saveSecondCompany(value) {
        return axiosJava.post('/secondDealer/saveSecondCompany', value)
    },
    saveSecondCompanyNew(value) {
        return axiosJava.post('/newSubService/saveSecondCompany', value)
    },
    strikeOut(value) {
        return axiosJava.post('/secondDealer/strikeOut', value)
    },
    getCompanyNameTwo(value) {
        return axiosJava.post('/secondaryDealerChange/getCompanyNameTwo', value)
    },
    getCompanyEmailTwo(value) {
        return axiosJava.post('/secondaryDealerChange/getCompanyEmailTwo', value)
    },
    submitSecondCompany(value) {
        return axiosJava.post('/secondDealer/submitSecondCompany', value)
    },
    submitSecondCompanyNew(value) {
        return axiosJava.post('/newSubService/submitSecondCompany', value)
    },
    confirmNoSubQuotient(value) {
        return axiosJava.post('/secondDealer/confirmNoSubQuotient', value)
    },
    getSecondDealerMessage(value) {
        return axiosJava.post('/jurisdiction/getSecondDealerMessage', value)
    },
    getMessage(value) {
        return axiosJava.post('/jurisdiction/getMessage', value)
    },
    getSecondCompany(value) {
        return axiosJava.post('/secondDealer/getSecondCompany', value)
    },
    getSecondCompanyNew(value) {
        return axiosJava.post('/newSubService/getSecondCompany', value)
    },
    throughSecondCompany(value) {
        return axiosJava.post('/secondDealer/through', value)
    },
    throughSecondCompanyNew(value) {
        return axiosJava.post('/newSubService/through', value)
    },
    unDo(value) {
        return axiosJava.post('/secondDealer/unDo', value)
    },
    changUnDo(value) {
        return axiosJava.post('/secondaryAuthorizationChange/changUnDo', value)
    },


    specialUnDo(value) {
        return axiosJava.post('/specialAuthorization/unDo', value)
    },
    firstJurisdictionUnDo(value) {
        return axiosJava.post('/firstJurisdictionController/unDo', value)
    },
    jurisdictionUnDo(value) {
        return axiosJava.post('/jurisdiction/unDo', value)
    },
    getAuthorizedSecondCompany(value) {
        return axiosJava.post('/secondDealer/getAuthorized', value)
    },
    searchCompanyName(value) {
        return axiosJava.post('/secondDealer/searchCompanyName', value)
    },
    searchEmail(value) {
        return axiosJava.post('/secondDealer/searchEmail', value)
    },
    getOneDate(value) {
        return axiosJava.post('/secondDealer/getOneDate', value)
    },
    getTwoDate(value) {
        return axiosJava.post('/secondDealer/getTwoDate', value)
    },
    getRegionByuserID(value) {
        return axiosJava.post('/distributor/getRegionByuserID', value)
    },
    getInformationOne(value) {
        return axiosJava.post('/homeDisplay/getInformationOne', value)
    },
    getAuthOne(value) {
        return axiosJava.post('/homeDisplay/getAuthOne', value)
    },
    saveEmail(value) {
        return axiosJava.post('/distributor/saveEmail', value)
    },
    getUserBuId(value) {
        return axiosJava.post('/distributor/getUserBuId', value)
    },
    getUserIdByNameChangeId(value) {
        return axiosJava.post('/distributor/getUserIdByNameChangeId', value)
    },
    getFlowType(value) {
        return axiosJava.post('/user/getFlowType', value)
    },
    getDealerChangeData(value) {
        return axiosJava.post('/secondaryDealerChange/getDealerChangeData', value)
    },
    //二级经销商续约
    getAuthorizeByBu(value) {
        return axiosJava.post('/SecondDealerRenewal/getAuthorizeByBu', value)
    },
    DealerRenewalInstall(value) {
        return axiosJava.post('/SecondDealerRenewal/install', value)
    },
    getSecondDealerRenewal(value) {
        return axiosJava.post('/SecondDealerRenewal/getSecondDealerRenewal', value)
    },
    //二级经销商授权指标
    getTargetByBu(value) {
        return axiosJava.post('/SecondAuthorizationIndicators/getTargetByBu', value)
    },
    dicatorsInstall(value) {
        return axiosJava.post('/SecondAuthorizationIndicators/install', value)
    },
    getDicators(value) {
        return axiosJava.post('/SecondAuthorizationIndicators/getDicators', value)
    },
    //二级经销商授权导出
    getExport(value) {
        return axiosJava.post('/distributor/export', value)
    },
    getSecondaryProduct(value) {
        return axiosJava.post('/secondaryAuthorizationChange/getSecondaryProduct', value)
    },
    getSecondaryCity(value) {
        return axiosJava.post('/secondaryAuthorizationChange/getSecondaryCity', value)
    },
    getSecondaryHospital(value) {
        return axiosJava.post('/secondaryAuthorizationChange/getSecondaryHospital', value)
    },
    getCheckChangeName(value) {
        return axiosJava.post('/distributor/getCheckChangeName', value)
    },
    //一级经销商BU
    getCompanyBuList(value) {
        return axiosJava.post('/distributor/getCompanyBu', value)
    },
    subOtherAgreements(value) {
        return axiosJava.post('/distributor/subOtherAgreements', value)
    },
    subOtherAgreementsApp(value) {
        return axiosJava.post('/distributor/subOtherAgreementsApp', value)
    },
    getOtherAgreements(value) {
        return axiosJava.post('/distributor/getOtherAgreements', value)
    },
    delAppOrder(value) {
        return axiosJava.post('/distributor/delAppOrder', value)
    },
    revoke(value) {
        return axiosJava.post('/distributor/revoke', value)
    },
    unDoTask(value) {
        return axiosJava.post('/undo/unDoTask', value)
    },
    getOtherAgreementsById(value) {
        return axiosJava.post('/distributor/getOtherAgreementsById', value)
    },

    getDaacList(value) {
        return axiosJava.post('/daacFile/getDaacList', value)
    },
    getProviderPersonnelInfo(value) {
        return axiosJava.post('/daacFile/getProviderPersonnelInfo', value)
    },
    updateDdinformation(value) {
        return axiosJava.post('/secondaryDdRenew/updateDdinformation', value)
    },
    getDocuments(value) {
        return axiosJava.post('/secondaryDdRenew/getDocuments', value)
    },
    insertDocuments(value) {
        return axiosJava.post('/secondaryDdRenew/insertDocuments', value)
    },
    getDdList(value) {
        return axiosJava.post('/secondaryDdRenew/getDdList', value)
    },
    getDdListById(value) {
        return axiosJava.post('/secondaryDdRenew/getDdListById', value)
    },
    importExcel(value) {
        return axiosJava.post('/user/importExcel', value)
    },

    saveReceive(value) {
        return axiosJava.post('/receiveController/saveReceive', value)
    },
    //查询母公司
    getAsf(value) {
        return axiosJava.post('/affiliatedCompanies/getAsf', value)
    },
    //查询关联公司
    selectAsfSun(value) {
        return axiosJava.post('/affiliatedCompanies/selectAsfSun', value)
    },
    getAffiliatedCompanies(value) {
        return axiosJava.post('/affiliatedCompanies/getAffiliatedCompanies', value)
    },
    subAffiliatedCompanies(value) {
        return axiosJava.post('/affiliatedCompanies/subAffiliatedCompanies', value)
    },
    subAffiliatedCompaniesApp(value) {
        return axiosJava.post('/affiliatedCompanies/subAffiliatedCompaniesApp', value)
    },
    getAffiliated(value) {
        return axiosJava.post('/affiliatedCompanies/getAffiliated', value)
    },
    javaModifyEmail(value) {
        return axiosJava.post('/user/modifyEmail', value)
    },
    checkEmail(value) {
        return axiosJava.post('/user/checkEmail', value)
    },
    getOneHospital(value) {
        return axiosJava.post('/specialAuthorization/getOneHospital', value)
    },
    addChannel(value) {
        return axiosJava.post('/undo/addChannel', value)
    },
    getChannelById(value) {
        return axiosJava.post('/undo/getChannelById', value)
    },
    delChannelById(value) {
        return axiosJava.post('/undo/delChannelById', value)
    },
    searchChannel(value) {
        return axiosJava.post('/undo/searchChannel', value)
    },
    getDealerList(value) {
        return axiosJava.post('/undo/getDealerList', value)
    },
    getOpinion(value) {
        return axiosJava.post('/wechat/getOpinion', value)
    },
    getCooperation(value) {
        return axiosJava.post('/wechat/getCooperation', value)
    },
    getConnperationList(value) {
        return axiosJava.post('/wechat/getConnperationList', value)
    },
    getChanelBuList() {
        return axiosJava.post('/wechat/getBuList')
    },
    getChanelProvinceArray() {
        return axiosJava.post('/wechat/getProvinceArray')
    },
    getChanelCityArray(value) {
        return axiosJava.post('/wechat/getCityArray', value)
    },
    getChanelHospitalArray(value) {
        return axiosJava.post('/wechat/getChanelHospitalArray', value)
    },
    setSales(value) {
        return axiosJava.post('/wechat/setSales', value)
    },

    intentionSales(value) {
        return axiosJava.post('/wechat/intentionSales', value)
    },
    getProblem(value) {
        return axiosJava.post('/wechat/getProblem', value)
    },
    updateProblem(value) {
        return axiosJava.post('/wechat/updateProblem', value)
    },
    selectAllProtocol(value) {
        return axiosJava.post('/ProtocolController/selectAll', value)
    },
    handleUpload(value) {
        return axiosJava.post('/ProtocolController/handleUpload', value)
    },
    TemplateUpload(value) {
        return axiosJava.post('/ProtocolController/TemplateUpload', value)
    },
    //获取返利列表信息
    getRebateMode(value) {
        return axiosJava.post('/rebateModeController/getRebateMode', value)
    },

    getToolDataList(value) {
        return axiosJava.post('/toolDataController/getToolDataList', value)
    },
    importExcelToolData(value) {
        return axiosJava.post('/toolDataController/importExcelToolData', value)
    },
    getDealerInventoryList(value) {
        return axiosJava.post('/dealerInventoryController/getDealerInventoryList', value)
    },
    importExcelDealerInventory(value) {
        return axiosJava.post('/dealerInventoryController/importExcelDealerInventory', value)
    },


    importExcelIMK(value) {
        return axiosJava.post('/dealerInventoryController/importExcelIMK', value)
    },

    exportIMK(value) {
        return axiosJava.post('/dealerInventoryController/exportIMK', value)
    },

    getDealerSalesList(value) {
        return axiosJava.post('/dealerSalesController/getDealerSalesList', value)
    },
    importExcelDealerSales(value) {
        return axiosJava.post('/dealerSalesController/importExcelDealerSales', value)
    },
    getAllDealerSalesList(value) {
        return axiosJava.post('/dealerSalesController/getAllDealerSalesList', value)
    },
    updateDealerSales(value) {
        return axiosJava.post('/dealerSalesController/updateDealerSalesById', value)
    },
    importExcelDealerSalesUploadList(value) {
        return axiosJava.post('/dealerSalesController/importExcelDealerSalesUploadList', value)
    },
    deleteDealerSalesById(value) {
        return axiosJava.post('/dealerSalesController/deleteDealerSalesById', value)
    },
    getAllDealerInventoryList(value) {
        return axiosJava.post('/dealerInventoryController/getAllDealerInventoryList', value)
    },
    updateDealerInventory(value) {
        return axiosJava.post('/dealerInventoryController/updateDealerInventory', value)
    },
    deleteDealerInventoryById(value) {
        return axiosJava.post('/dealerInventoryController/deleteDealerInventoryById', value)
    },
    updateDealerInventoryList(value) {
        return axiosJava.post('/dealerInventoryController/updateDealerInventoryList', value)
    },

    getIMKInfoList(value) {
        return axiosJava.post('/dealerInventoryController/getIMKInfoList', value)
    },

    getUserList(value) {
        return axiosJava.post('/user/getAccountNumberUserList', value)
    },

    getAuthorizationReportList(value) {
        return axiosJava.post('/user/getAuthorizationReportList', value)
    },
    deleteDealerInventoryList(value) {
        return axiosJava.post('/dealerInventoryController/deleteDealerInventoryList', value)
    },
    dealerSalesList(value) {
        return axiosJava.post('/dealerSalesController/dealerSalesList', value)
    },
    getUploadDate(value) {
        return axiosJava.post('/dealerSalesController/getUploadDate', value)
    },
    uploadDateById(value) {
        return axiosJava.post('/dealerSalesController/uploadDateById', value)
    },
    updateUploadDate(value) {
        return axiosJava.post('/dealerSalesController/updateUploadDate', value)
    },
    save_or_submit(value) {
        return axiosJava.post('/daacFile/saveOrSubmit', value)

    },
    init_spn(value) {
        return axiosJava.post('/daacFile/initSpn', value)

    },
    is_problem_new(value) {
        return axiosJava.post('/daacFile/is_problem_new', value)

    },

    add_user(value) {
        return axiosJava.post('/daacFile/add_user', value)

    },

    getBeSalesList(value) {
        return axiosJava.post('/daacFile/getBeSalesList', value)

    },

    approvalProvider(value) {
        return axiosJava.post('/daacFile/approvalProvider', value)

    },
    approvalProviderPersonnelContractRenewal(value) {
        return axiosJava.post('/ProviderPersonnelContractRenewal/approvalProviderPersonnelContractRenewal', value)
    },
    selectExcelDownload(value) {
        return axiosJava.post('/ProtocolController/selectExcelDownload', value)

    },

    is_send_sales(value) {
        return axiosJava.post('/daacFile/is_send_sales', value)
    },
    getProvinceSalesList(value) {
        return axiosJava.post('/daacFile/getProvinceSalesList', value)

    },
    checkAuthorizationType(value) {
        return axiosJava.post('/specialAuthorization/checkAuthorizationType', value)

    },
    getAllByNameAndPhone(value) {
        return axiosJava.post('/ProviderPersonnelContractRenewal/getAllByNameAndPhone', value)
    },
    saveandsubmit(value) {
        return axiosJava.post('/ProviderPersonnelContractRenewal/saveandsubmit', value)
    },
    saveProPerEnd(value) {
        return axiosJava.post('/daacFile/save_pro_per_end', value)
    },
    check_personnel_phone(value) {
        return axiosJava.post('/daacFile/check_personnel_phone', value)
    },
    checkPhone(value) {
        return axiosJava.post('/receiveController/checkPhone', value)
    },
    checkEmailBox(value) {
        return axiosJava.post('/receiveController/checkReceiveEmail', value)
    },

    selectExcelDownloadKong(value) {
        return axiosJava.post('/ProtocolController/selectExcelDownloadKong', value)
    },
    selectAllWatermark(value) {
        return axiosJava.post('/WatermarkController/selectAll', value)
    },
    watermarkUpload(value) {
        return axiosJava.post('/WatermarkController/watermarkUpload', value)
    },
    worldWatermark(value) {
        return axiosJava.post('/WatermarkController/worldWatermark', value)
    },
    get_director_list(data) {
        return axiosJava.post('/daacFile/get_director_list', data)
    },
    is_problem_new_one(value) {
        return axiosJava.post('/daacFile/is_problem_new_one', value)

    },
    is_problem_new_region(value) {
        return axiosJava.post('/daacFile/is_problem_new_region', value)

    },
    check_vendor(value) {
        return axiosJava.post('/daacFile/check_vendor', value)

    },
    undoProviderAdd(value) {
        return axiosJava.post('/daacFile/undoProviderAdd', value)

    },
    undoProviderRenewal(value) {
        return axiosJava.post('/daacFile/undoProviderRenewal', value)

    },
    get_provider_personnel(value) {
        return axiosJava.post('/daacFile/get_provider_personnel', value)

    },
    delete_provider_personnel_info_work(value) {
        return axiosJava.post('/daacFile/delete_provider_personnel_info_work', value)

    },

  selectOneFinished(value) {
    return axiosJava.post('/ddMonitorController/selectOneFinished', value)
  },
  UpdateDDMonitor(value) {
    return axiosJava.post('/ddMonitorController/UpdateDDMonitor', value)
  },
  selectDDMonitor(value) {
    return axiosJava.post('/ddMonitorController/selectDDMonitor', value)
  },
  selectGroupCount(value) {
    return axiosJava.post('/ddMonitorController/selectGroupCount', value)
  },
  UpdateDDChange(value) {
    return axiosJava.post('/ddMonitorController/UpdateDDChange', value)
  },
  ForgotPassword(value) {
    return axiosJava.post('/user/forgotPassword', value)
  },
  selectDDInfo(value) {
    return axiosJava.post('/ddMonitorController/selectDDInfo', value)
  },
  getType(value) {
   return axiosJava.post('/infoapproval/getInfoType', value)
  },
  getApprovalType() {
    return axiosJava.post('/ShareMessApply/getApprovalType')
  },
  getInfoApprovalList(value){
      return axiosJava.post('/ShareMessApply/getList',value)
  },
  insertMessage(value) {
    return axiosJava.post('/message/insertMessage', value)
  },
  applyMessage(value) {
    return axiosJava.post('/message/applyMessage', value)
  },
  getCountInforRec(value) {
    return axiosJava.post('/message/getInternalPerson', value)
  },
  getMessageInfo(value) {
    return axiosJava.post('/message/getMessageInfo', value)
  },
  getMessageList(value) {
    return axiosJava.get('/message/getMessageList', value)
  },
  fileUpload(file) {
    return axiosJava.post('/message/fileUpload', file)
  },
  getProductLineListByBu(value) {
    return axiosJava.post('/message/getProductLineListByBu', value)
  },
  addNewTypeName(value){
    return axiosJava.post('/ShareMessApply/insertNewTypeName',value)
  },
  selectOneCompany(value) {
    return axiosJava.post('/message/selectOneCompany', value)
  },
  selectSecondaryCompany(value) {
    return axiosJava.post('/message/selectSecondaryCompany', value)
  },
  translateProduct(value) {
    return axiosJava.post('/message/translateProduct', value)
  },
  translateCompany(value) {
    return axiosJava.post('/message/translateCompany', value)
  },
  initMessageApplyInfo(value) {
    return axiosJava.post('/ShareMessageApply/initMessageApplyInfo', value)
  },
  getApprovalName(value){
      return axiosJava.post('/ShareMessApply/getApprovalName',value)
  },
  getBuList(){
      return axiosJava.post('/infoReadReport/getBu')
  },
  getDepartment(){
      return axiosJava.post('/infoReadReport/getDepartment')
  },
  selectMessagesPC(value){
    return axiosJava.post('/message/selectMessagesPC',value)
  },
  // 查询内部人员部门
  getInsideDepartment(){
    return axiosJava.post('/message/getInsideDepartment')
  },
  selectFeedbacksPC(value){
    return axiosJava.post('/shareMessageFeedback/selectFeedbacksPC',value)
  },
  getDealerLists(value){
      return axiosJava.post('/ShareMessageReceiverSend/getDealerList',value)
  },
  getInsidersLists(value){
    return axiosJava.post('/ShareMessageReceiverSend/getInsidersList',value)
  },
  getExcel(value){
      return axiosJava.get('/ShareMessageReceiverSend/exportDealer?'+ value)
  },
  selectApplys(value){
    return axiosJava.post('/ShareMessageApply/selectApplys', value)
  },
  getInforMationList(value){
      return axiosJava.post('/ShareMessageReceiverSend/getInforMationList',value)
  },
  getTypeTen() {
    return axiosJava.post('/infoapproval/getInfoTypeTen')
  },
  judgmentRole(value) {
      return axiosJava.post('/ShareMessageReceiverSend/judgmentRole',value)
  },
  selectContent(value) {
      return axiosJava.post('/message/selectContent',value)
  },
  getTypeAll(){
      return axiosJava.post('/infoapproval/getInfoTypeAll')
  },
  selectInfoReceive(value){
      return axiosJava.post('/receiveController/selectInfoReceive',value)
  },
  getUserMessage(value){
      return axiosJava.post('/ShareMessageReceiverSend/getUserMessage',value)
  },
  insertUserMessage(value){
      return axiosJava.post('/ShareMessageReceiverSend/insertMessage',value)
  },
  updateIsRead(value){
      return axiosJava.post('/ShareMessageReceiverSend/updateIsRead',value)
  },
  insertDDMonitor(value){
    return axiosJava.post('/ddMonitorController/insertDDMonitor',value)
  },
  gethoList(){
      return axiosJava.post('/tripartiteAgreementManagementController/getHospitalList')
  },
  getListBu(){
      return axiosJava.post('/tripartiteAgreementManagementController/getBuList')
  },
  getTripartiteData(value){
      return axiosJava.post('/tripartiteAgreementManagementController/getTableData',value)
  },
  insertTripartiteData(value){
      return axiosJava.post('/tripartiteAgreementManagementController/insertTripartiteData',value)
  },
  doesItExist(value){
      return axiosJava.post('/tripartiteAgreementManagementController/doesItExist',value)
  },
  exportOut(value){
    return axiosJava.post('/tripartiteAgreementManagementController/exportOut',value)
  },
  // 查询合同类型
  getContractTypeList(value) {
    return axiosJava.post('/ShareContractType/getContractTypeList', value)
  },
  // 筛选项查询公司
  getContractTemplateCompany(value) {
    return axiosJava.post('/ShareContractTemplate/getContractTemplateCompany', value)
  },
  // 批量添加公司合同模板
  insertContractTemplateList(value) {
    return axiosJava.post('/ShareContractTemplate/insertContractTemplateList', value)
  },
  // 查询BU部门
  getBuSegmentList(value) {
    return axiosJava.post('/BuSegmentController/getBuSegmentList', value)
  },
  updateTripartiteData(value){
      return axiosJava.post('/tripartiteAgreementManagementController/updateTripartiteData',value)
  },
  updateStart(value){
    return axiosJava.post('/tripartiteAgreementManagementController/updateStart',value)
  },
  echoData(value){
    return axiosJava.post('/tripartiteAgreementManagementController/echoData',value)
  },
  judgeBu(value){
      return axiosJava.post('/tripartiteAgreementManagementController/judgeBu',value)
  },
  existenceIsReasonabled(value){
    return axiosJava.post('/tripartiteAgreementManagementController/existenceIsReasonabled',value)
  },
  saveMessage(value){
    return axiosJava.post('/qrcode/saveMessage',value)
  },
  selectQrcodeMessage(value){
    return axiosJava.post('/qrcode/selectQrcodeMessage',value)
  },
    setProvince(value){
        return axiosJava.post('/tripartiteAgreementManagementController/setProvince',value)
    },
    getPersonnelOldList(value){
        return axiosJava.post('/newSubService/getPersonnelOldList',value)
    },
    getApprovalDate(value){
        return axiosJava.post('/ddMonitorController/getApprovalDate',value)
    },
    getPersonnelOldListOne(value){
        return axiosJava.post('/newSubService/getPersonnelOldListOne',value)
    },

    getSecondaryAuthOld(value){
        return axiosJava.post('/SecondAuthorizationIndicators/getSecondaryAuthOld',value)
    },
    getEmpowermentinfoJava(value){
        return axiosJava.post('/daacFile/getEmpowermentinfoJava',value)
    },
    isRpl(value){
        return axiosJava.post('/daacFile/isRpl',value)
    },
    selectBuNewList(value){
        return axiosJava.post('/buNew/selectBuNewList',value)
    },

    addBuNew(value){
        return axiosJava.post('/buNew/addBuNew',value)
    },

    getUserList_new(value){
        return axiosJava.post('/buNew/getUserList_new',value)
    },
    getBuList_new(value){
        return axiosJava.post('/buNew/getBuList_new',value)
    },
    startOrEnd(value){
        return axiosJava.post('/buNew/startOrEnd',value)
    },

    del_bu(value){
        return axiosJava.post('/buNew/del_bu',value)
    },
    getBuHeadList_new(value){
        return axiosJava.post('/buNew/getBuHeadList_new',value)
    },
    saveBuHead_new(value){
        return axiosJava.post('/buNew/saveBuHead_new',value)
    },
    startOrEndBuHead(value){
        return axiosJava.post('/buNew/startOrEndBuHead',value)
    },

    find_user_email(value) {
        return axiosJava.post('/daacFile/find_user_email',value)
    },

    get_bu_list_select() {
        return axiosJava.post('/buNew/get_bu_list_select')
    },

    get_product_list(value) {
        return axiosJava.post('/buNew/get_product_list', value)
    },

    search_bu_product_list(value) {
        return axiosJava.post('/buNew/search_bu_product_list', value)
    },

    add_bu_product(value) {
        return axiosJava.post('/buNew/add_bu_product', value)
    },

    del_bu_product(value) {
        return axiosJava.post('/buNew/del_bu_product', value)
    },

    search_area_list(value) {
        return axiosJava.post('/buNew/search_area_list', value)
    },
    delAreaById(value) {
        return axiosJava.post('/buNew/del_area', value)
    },
    save_area(value) {
        return axiosJava.post('/buNew/save_area', value)
    },

    get_dd_information_list(value) {
        return axiosJava.post('/daacFile/get_dd_information_list', value)
    },

    getBuList_all_new(value){
        return axiosJava.post('/buNew/getBuList_all_new',value)
    },

    get_region_list() {
        return axiosJava.post('/buNew/get_region_list')
    },

    get_area_array() {
        return axiosJava.post('/buNew/get_area_array')
    },

    get_product_list_tree(value) {
        return axiosJava.post('/buNew/get_product_list_tree', value)
    },

    get_medical_business_license_scope() {
        return axiosJava.post('/buNew/get_medical_business_license_scope')
    },

    search_product_check(value) {
        return axiosJava.post('/buNew/get_search_product_check', value)
    },

    del_product_check(value) {
        return axiosJava.post('/buNew/del_product_check', value)
    },

    save_product_check(value) {
        return axiosJava.post('/buNew/save_product_check', value)
    },

    search_province_manager(value) {
        return axiosJava.post('/buNew/search_province_manager', value)
    },

    save_province_manager(value) {
        return axiosJava.post('/buNew/save_province_manager', value)
    },


    del_province_manager(value) {
        return axiosJava.post('/buNew/del_province_manager', value)
    },

    search_rpl(value) {
        return axiosJava.post('/buNew/search_rpl', value)
    },

    save_rpl(value) {
        return axiosJava.post('/buNew/save_rpl', value)
    },

    del_rpl(value) {
        return axiosJava.post('/buNew/del_rpl', value)
    },

    check_vendor_type(value) {
        return axiosJava.post('/vendor/check_vendor_type', value)
    },
    save_company(value) {
        return axiosJava.post('/vendor/save_company', value)
    },
    save_two_company(value) {
        return axiosJava.post('/vendor/save_two_company', value)
    },
    delete_draft(value){
        return axiosJava.post('/vendor/delete_draft',value)
    },

    search_erp_sap(value){
        return axiosJava.post('/buNew/search_erp_sap',value)
    },

    search(value){
        return axiosJava.post('/accountNum/search',value)
    },

    getById(value){
        return axiosJava.post('/accountNum/getById',value)
    },
    updateById(value){
        return axiosJava.post('/accountNum/updateById',value)
    },
    getUnilateralTerminationStampList(value){
        return axiosJava.post('/daacFile/getUnilateralTerminationStampList',value)
    },

    search_product_list(value){
        return axiosJava.post('/buNew/search_product_list',value)
    },
    add_product(value){
        return axiosJava.post('/buNew/add_product',value)
    },
    del_product(value){
        return axiosJava.post('/buNew/del_product',value)
    },
    copy_product(value){
        return axiosJava.post('/buNew/copy_product',value)
    },

    import_bu_product(value) {
        return axiosJava.post('/buNew/import_bu_product', value)
    },
    import_product_check(value) {
        return axiosJava.post('/buNew/import_product_check', value)
    },
    get_vendor_type_list() {
        return axiosJava.post('/buNew/get_vendor_type_list')
    },
    get_my_vendor_type_list(value) {
        return axiosJava.post('/buNew/get_my_vendor_type_list', value)
    },

    get_my_vendor_type_shoquan_list(value) {
        return axiosJava.post('/buNew/get_my_vendor_type_shoquan_list', value)
    },
    check_other_agree_bu(value) {
        return axiosJava.post('/buNew/check_other_agree_bu', value)
    },
    search_auth(value){
        return axiosJava.post('/accountNum/search_auth',value)
    },
    updateUserAuth(value){
        return axiosJava.post('/accountNum/updateUserAuth',value)
    },

    search_apply_role(value){
        return axiosJava.post('/accountNum/search_apply_role',value)
    },
    get_role_list(){
        return axiosJava.post('/accountNum/get_role_list')
    },

    get_permissions(value){
        return axiosJava.post('/accountNum/get_permissions', value)
    },

    set_user_role(value){
        return axiosJava.post('/accountNum/set_user_role', value)
    },

    get_menu_list(){
        return axiosJava.post('/accountNum/get_menu_list')
    },

    search_menu_role(value){
        return axiosJava.post('/accountNum/search_menu_role', value)
    },

    set_menu_role(value){
        return axiosJava.post('/accountNum/set_menu_role', value)
    },

    search_bu_region(value){
        return axiosJava.post('/buNew/search_bu_region',value)
    },

    save_region(value){
        return axiosJava.post('/buNew/save_region',value)
    },

    get_bu_region_array(value){
        return axiosJava.post('/buNew/get_bu_region_array',value)
    },

    select_country() {
        return axiosJava.post('/buNew/select_country')
    },

    add_country(value) {
        return axiosJava.post('/buNew/add_country', value)
    },

    del_country(value) {
        return axiosJava.post('/buNew/del_country',value)
    },


    del_region(value) {
        return axiosJava.post('/buNew/del_region',value)
    },

    search_user(value){
        return axiosJava.post('/accountNum/search_user',value)
    },


    updateLock(value){
      return axiosJava.post('/accountNum/updateLock',value)
    },

    setUserIsActive(value){
        return axiosJava.post('/accountNum/setUserIsActive',value)
    },

    search_user_init(){
        return axiosJava.post('/accountNum/search_user_init')
    },

    save_user(value){
        return axiosJava.post('/accountNum/save_user',value)
    },

    check_user(value){
        return axiosJava.post('/accountNum/check_user',value)
    },
    import_user(value){
        return axiosJava.post('/accountNum/import_user',value)
    },
    setLock(value) {
      return axiosJava.post('/user/setLock', value)
    },

  reload_all_password() {
    return axiosJava.post('/user/reload_all_password')
  }
}



// WEBPACK FOOTER //
// ./src/api/services/webfunction.js